export default __webpack_public_path__ + "static/media/Outfit-Black.5027173f.ttf";